export const emailVerificationStatus = {
  VERIFIED: "verified",
  EXPIRED: "expired",
};

export const emailVerificationCode = {
  VERIFICATION_EXPIRED: 4070001,
  VERIFICATION_PASSED: 1080002,
};
